import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_SUBJECT,
  GET_SUBJECTS,
  // GET_SUBJECTS_BY_FILTER,
  GET_SUBJECT_BY_CODE_OR_NAME,
  GET_SUBJECT_BY_SUBJECTGROUP_ID,
  ADD_SUBJECT,
  UPDATE_SUBJECT,
  DELETE_SUBJECT
} from '@/queries/modules/common-data/subject';

export async function getSubjects(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_SUBJECTS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.subject;
    } else {
      context.commit('setSubjects', data.getSubjects);
      context.commit('setSuccess', null);
      return data.getSubjects
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

/*export async function getSubjectsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_SUBJECTS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSubjects', data.getSubjectsByFilter);
      context.commit('setSuccess', null);

      return data.getSubjectsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}*/

export async function getSubjectsByCodeOrName(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_SUBJECT_BY_CODE_OR_NAME,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSubjects', data.getSubjectsByCodeOrName);
      context.commit('setSuccess', null);

      return data.getSubjectsByCodeOrName;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getSubjectBySubjectGroupID(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_SUBJECT_BY_SUBJECTGROUP_ID,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSubjects', data.getSubjectsBySubjectGroup);
      context.commit('setSuccess', null);

      return data.getSubjectsBySubjectGroup;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getSubject(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_SUBJECT,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.subject;
    } else {
      context.commit('setSubject', data.getSubject);
      context.commit('setSuccess', null);
      return data.getSubject
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function addSubject(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_SUBJECT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const subjects = [...context.state.subjects];
      subjects.push(data.addSubject);
      context.commit('setSubjects', subjects);
      context.commit('setSuccess', newItemSuccess(data.addSubject.nameLocal));

      return data.addSubject
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateSubject(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_SUBJECT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.subjects.findIndex(item => item.id === data.updateSubject.id);
      const subjects = [
        ...context.state.subjects.slice(0, index),
        data.updateSubject,
        ...context.state.subjects.slice(index + 1)
      ];
      context.commit('setSubjects', subjects);
      context.commit('setSuccess', updateItemSuccess(data.updateSubject.nameLocal));

      return data.updateSubject
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteSubject(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_SUBJECT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.subjects.findIndex(item => item.id === data.deleteSubject.id);
      const subjects = [
        ...context.state.subjects.slice(0, index),
        ...context.state.subjects.slice(index + 1)
      ];
      context.commit('setSubjects', subjects);
      context.commit('setSuccess', deleteItemSuccess(data.deleteSubject.nameLocal));

      return data.deleteSubject
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

